<template>
    <div class="box-warranty-check container-fluid">
        <Hotline/>
        <FormInfo :screen="'check'" :lstData="settings" :key="componentKeyForm"/>
        <AppInfo :lstData="settings" :key="componentKeyApp"/>
        <Footer :lstData="settings" :key="componentKey"/>
    </div>
</template>

<script>
import Hotline from './warranty_check_hotline'
import FormInfo from './form_check'
import AppInfo from './app_info_check'
import Footer from './footer'
import DataServices from '@/core/DataServices'
export default {
    components: {
      Hotline,
      Footer,
      AppInfo,
      FormInfo
    },
    data() {
        return {
            settings: [],
            componentKey: Math.random() * 301,
            componentKeyApp: Math.random() * 201,
            componentKeyForm: Math.random() * 101
        }
    },
    created () {
        this.getSettings();
    },
    methods: {
        async getSettings() {
            var data = await DataServices.getList('settings', {'fields' : 'key value'});
            if (data != undefined && data != null && data[Object.keys(data)].length) {
                var objs =  data[Object.keys(data)];
                this.settings = objs;
                this.componentKey = Math.random() * 301;
                this.componentKeyApp = Math.random() * 201;
                this.componentKeyForm = Math.random() * 101;
            }
        }
    }
}
</script>

<style lang="scss">
 body{background:#fff ; overflow-x: hidden;
    .box-warranty-check{padding: 0;
        .box-check-body {
            .description{display: none;}
            .box-error{font-size: 14px;}
        }
        .box-form-check{
            .box-form-check-header{
                .box-absolute{ position: relative;}
            }
        }
        .box-app-info{ background: transparent;overflow: hidden;
            &::before{content: ""; position: absolute; overflow: hidden; width: 104%; height: 100%; left: -3%; top: 23%; z-index: -1;  background: #f5f5f7; transform: rotate(2deg); }
        }
    }
    .error{color: #f00;}
}

@media screen  and (max-width: 1366px) and (min-width: 991px){
    .box-app-info {
        .box-app-check-body {
            .box-app-check-body-item {width: 450px;
                &.app-check-body-right{margin-left: 10px; width: 500px;
                    .download-info {
                        .download-info-item {
                            .display-flex {
                                &.download-info-item-right{width: calc(100% - 100px);}
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen  and (max-width: 991px){
    .box-form-check {padding: 0 11.25px ; margin-top: 75px;
        .row {margin: 0; }
        .box-form-check-header{
            .form-input {width: 100% !important;
                .form-input-group{height: 58px !important;}
            }
            .box-absolute {
                .box-logo {width: 75.61px; height: 63.51px;}
            }
        }
    }
    .box-app-info {padding: 11.25px; margin-top: 75.23px; padding-bottom: 37.5px;
        .box-app-check-body {
            .download-title-mobile{display: block; text-align: center; margin-bottom: 24.00px;font-size: 30px; line-height: 35px;}
            .border-box-app-mobile{display: block; margin: 0 auto;}
            .box-app-check-body-item { float: none; width: 100%; text-align: center;
                &.app-check-body-right{margin: 0;text-align: left; height: auto; 
                    .border-box-app{display: none;}
                    .download-title{display: none;}
                    .download-info{margin-top: 16.11px;
                        .download-link{margin-top: 24px; /* margin-left: 15px;*/
                            .image-store {width: 135px; height: 40px; display: inline-block;
                                img{height: auto !important; width: auto !important; }
                            }
                        }
                        .download-info-item{margin-left: 0; margin-right: 10px; width: 100%;
                            .download-info-item-right{width: calc(100% - 121px) !important;}
                            .download-info-item-img {
                                img{margin-top: 15px;}
                            }
                        }
                    }
                }
            }
        }
    }
    .box-warranty-check {
        .footer-check { height: 124px !important; display: flex;align-items: center;
            .footer-format{padding: 0 !important; height: auto !important;
                .footer-policy{float: none !important; }
                .footer-info{float: none !important; margin-top: 12px; font-size: 17px !important; line-height: 22px !important;}
            }
        }
        // .box-app-info {
        //     &::before {left: 0% !important;}
        // }
    }
 }
@media screen  and (max-width: 767px){
    .box-app-info{overflow: hidden;}
    
    .box-app-check-body-item{min-width: inherit !important; height: auto !important;
        img{height: auto !important;}
    }
}
@media screen  and (max-width: 756px) and (min-width: 575px){
    .box-app-info {
        .box-app-check-body {
            .box-app-check-body-item {
                &.app-check-body-right{
                    .download-info{
                        .download-info-item{
                            .download-info-item-img {height: 63px;}
                        }
                    }
                }
            }
        }
    }
}
@media screen  and (max-width: 441px){
    .box-app-info{overflow: hidden;
        &::before { width: 110% !important; height: 110%  !important; left: -8%  !important; transform: rotate(1deg)  !important;
        }
    }
}
</style>